module.exports = __webpack_public_path__ + "img/buy.dbbbf900.png";